import { PdfCellType } from './pdf-cell-type.enum';

export class PdfColDef {

    header: string;
    type: PdfCellType;
    width: string;

    constructor(header: string, type?: PdfCellType, width?: string) {
        this.header = header;
        this.type = type ? type : PdfCellType.TEXT;
        this.width = width ? width : 'auto';
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-col-def.ts